
import { Booking, Summary } from "../../state/models";
import { isAgent, pushEvent } from "./pushEvent";

export function pushPurchaseEvent({booking, summary}: {booking: Booking, summary: Summary}) {

  if(isAgent()) return;
  
  if(!booking || booking.bookingStatus !== 'Confirmed') return;
  if(!summary || !Array.isArray(summary.segments) || summary.bookingTotal < 0) return;

  const items = summary.segments.map(segment => ({
    item_id: `${segment.carrierCode}${segment.flightNumber}@${segment.departureDate}`,
    item_name: `${segment.originCode}-${segment.destinationCode}@${segment.departureDate}`,
    item_category: 'flight',
    price: segment.segmentTotal,
    tax: segment.taxTotal,
    quantity: booking.passengers.length
  }));

  const data = {
    transaction_id: booking.pnr,
    currency: summary.currencyCode,
    value: summary.bookingTotal,
    tax: items.reduce((acc, item) => acc + item.tax, 0),
    items
  }

  pushEvent({ event: 'purchase', data})
}